import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './index.styl';

import Button from 'core/components/Button';
import ButtonWithIcon from 'core/components/ButtonWithIcon';
import CommentsCount from 'core/components/CommentsCount';
import withTheme from 'core/hocs/withTheme';

import { resolveScopedStyles } from 'core/utils/styled-jsx';

import themePropTypes from 'core/utils/prop-types/theme';
import { withRouter } from 'core/libs/router';

function CommentButton(props) {
  const {
    xid,
    history,
    commentsUrl,
    className,
    theme: {
      controls: {
        topicFooter: {
          commentButton: {
            text,
            type,
            textTransform,
            font: buttonFont,
            size,
            icon: {
              Icon,
              position,
              width: iconWidth,
              height: iconHeight,
              showValueInIcon,
            },
          },
        },
      },
    },
  } = props;

  const pushToHistory = () => {
    history.push(commentsUrl);
  };

  const buttonProps = { type, position, size, className };

  const scope = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .buttonContent
          :global(* + &)
          :global(& + *)
            margin-left 10px
          display flex
          text-transform ${textTransform}
          font ${buttonFont}
      `}</style>
    </scope>
  );

  if (typeof Icon !== 'function') {
    return (
      <Button onClick={pushToHistory} {...buttonProps}>
        <div className={scope.wrapClassNames('buttonContent')}>
          {text}
          <div className={cx(
            styles.buttonCount,
            !showValueInIcon && styles._withBrackets
          )}
          >
            <CommentsCount
              xid={xid}
              disableIcon
            />
          </div>
        </div>
        <scope.styles />
      </Button>
    );
  }

  const CountWithoutIcon = () => (
    <CommentsCount
      xid={xid}
      disableIcon
      renderZero
    />
  );

  const ButtonIcon = () => (
    <Icon
      width={iconWidth}
      height={iconHeight}
      {...showValueInIcon && { value: <CountWithoutIcon /> }}
    />
  );

  return (
    <ButtonWithIcon
      icon={ButtonIcon}
      onClick={pushToHistory}
      {...buttonProps}
    >
      <div className={scope.wrapClassNames('buttonContent')}>
        {text}
        {!showValueInIcon &&
          <div className={cx(
            styles.buttonCount,
            styles._withBrackets
          )}
          >
            <CommentsCount
              xid={xid}
              disableIcon
            />
          </div>
        }
      </div>
      <scope.styles />
    </ButtonWithIcon>
  );
}

CommentButton.propTypes = {
  className: PropTypes.string,
  theme: themePropTypes(`{
    controls: {
      topicFooter: {
        commentButton: {
          text,
          textTransform,
          type,
          size,
          icon: {
            position,
            width,
            height,
          }
        }
      }
    }
  }`),
  xid: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  commentsUrl: PropTypes.string.isRequired,
};

export default withRouter(withTheme(CommentButton));
